var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"3","viewBox":"0 0 14 3","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 1.5H14","stroke":_vm.getAssets.primaryBrandColor || '#D1202D',"stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }